module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-357.5b17c23.woff2";